import { naverSearchQuery } from "types/types.naver";
import api from "../axios/NaverApi";

export const getNewsData = async (body: naverSearchQuery) => {
  const response = await api.get(
    `/v1/naver/search/news?query=${body.query}&display=${body.display}&start=${body.start}&sort=${body.sort}`
  );
  return response.data;
};
